var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowcircleleft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 2.66675C8.65317 2.66675 2.6665 8.65341 2.6665 16.0001C2.6665 23.3467 8.65317 29.3334 15.9998 29.3334C23.3465 29.3334 29.3332 23.3467 29.3332 16.0001C29.3332 8.65341 23.3465 2.66675 15.9998 2.66675ZM18.3865 20.0001C18.7732 20.3867 18.7732 21.0267 18.3865 21.4134C18.1865 21.6134 17.9332 21.7067 17.6798 21.7067C17.4265 21.7067 17.1732 21.6134 16.9732 21.4134L12.2665 16.7067C12.0805 16.5186 11.9762 16.2647 11.9762 16.0001C11.9762 15.7355 12.0805 15.4816 12.2665 15.2934L16.9732 10.5867C17.3598 10.2001 17.9998 10.2001 18.3865 10.5867C18.7732 10.9734 18.7732 11.6134 18.3865 12.0001L14.3865 16.0001L18.3865 20.0001Z",
    fill: "#E1E1E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowcircleleft);
export default __webpack_public_path__ + "static/media/arrowcircleleft.5592b8a968e5f75bbab853d3e11abe36.svg";
export { ForwardRef as ReactComponent };